import * as React from 'react';
import * as lottie from 'lottie-web';

interface Props {
  animationData: any;
  isVisible: boolean;
  speed?: number;
  loop?: boolean;
  autoplay?: boolean;
  startIndex?: number;
}

const Loader: React.FC<Props> = props => {
  let loaderWrapper: any = null;
  let anim: any;

  React.useEffect(() => {
    const animData = {
      wrapper: loaderWrapper,
      animType: 'svg',
      loop: typeof props.loop !== 'undefined' ? props.loop : true,
      prerender: true,
      autoplay: typeof props.autoplay !== 'undefined' ? props.autoplay : true,
      animationData: props.animationData,
    };
    // @ts-ignore
    anim = lottie.loadAnimation(animData);
    anim.setSpeed(props.speed || 1);

    anim.goToAndPlay(props.startIndex ? props.startIndex : 0);

    return function cleanup() {
      anim.destroy();
    };
  }, [props.animationData]);

  return <div ref={image => (loaderWrapper = image)} id="loader" />;
};

export default Loader;
try {
    // @ts-ignore
    loader.displayName = "loader";
    // @ts-ignore
    loader.__docgenInfo = { "description": "", "displayName": "loader", "props": { "animationData": { "defaultValue": null, "description": "", "name": "animationData", "required": true, "type": { "name": "any" } }, "isVisible": { "defaultValue": null, "description": "", "name": "isVisible", "required": true, "type": { "name": "boolean" } }, "speed": { "defaultValue": null, "description": "", "name": "speed", "required": false, "type": { "name": "number" } }, "loop": { "defaultValue": null, "description": "", "name": "loop", "required": false, "type": { "name": "boolean" } }, "autoplay": { "defaultValue": null, "description": "", "name": "autoplay", "required": false, "type": { "name": "boolean" } }, "startIndex": { "defaultValue": null, "description": "", "name": "startIndex", "required": false, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/loader/loader.tsx#loader"] = { docgenInfo: loader.__docgenInfo, name: "loader", path: "src/components/loader/loader.tsx#loader" };
}
catch (__react_docgen_typescript_loader_error) { }